import PropTypes from 'prop-types';
import React from 'react';
//import { useState } from "react";
import { withTranslation } from 'react-i18next';
import { Paper, TablePagination } from '@material-ui/core';
import { Tooltip2, Classes } from '@blueprintjs/popover2';
import MTable, { MTableBodyRow } from 'material-table';
import { Button } from '@blueprintjs/core';
import { CsvBuilder } from "filefy";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ShuffleIcon from '@material-ui/icons/Shuffle';
import Sync from '@material-ui/icons/Sync';


import { corpusConcordsShape } from './shapes';
import { prepDangerouslySetInnerHTMLString, specialSlice, formatMeta } from './utils';
import { stripBracket } from '../../../utils';
import { PUBLIC_URL, ANALYTICS_URL, SERVER_URL} from '../../../constants'
import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME } from '../../../auth/constants';

import ViewColumnIcon from "@material-ui/icons/ViewColumn";

import './KwicTable.css';
//import './UnfoldedView.css';
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";

// (navigator.userAgent.indexOf("Chrome") != -1)



class KwicTable extends React.PureComponent {

  state = {
    shuffled:false,
  };

  shuffleArray = (array) => {
    let curId = array.length;
    // There remain elements to shuffle
    while (0 !== curId) {
      // Pick a remaining element
      let randId = Math.floor(Math.random() * curId);
      curId -= 1;
      // Swap it with the current element.
      let tmp = array[curId];
      array[curId] = array[randId];
      array[randId] = tmp;
    }
    return array;
  }

  metadata = (rowData) => {
    if (this.props.docMeta[rowData.docId]) {
      const items=Object.keys(this.props.docMeta[rowData.docId]).sort().map( (key,i) => <li key={key+i.toString()} >{key} : {this.props.docMeta[rowData.docId][key]}</li>)
      return <ul>{items}</ul>;
    } else {
      // TODO : corriger ce bogue
      console.log("docId pas dans docMeta : ",rowData.docId);
    } 
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log('oldProps',this.props);
  //   console.log('newProps',nextProps)
  //   console.log('oldState',this.state);
  //   console.log('newState',nextState)    
  // }


  // KwicTable = React.memo( function KwicTable({ concords, t, selectedSentId, permalink, isOpenMetadata, getConcordDetail, openConlluPopup, lang, concordSpan, collections, docMeta }) {

  // NB : avant on déclarait KwicTable comme fonction composant (et non comme classe)
  // du coup, pour se référer à son état, il fallait utiliser useState (qui renvoie la valeur actuelle et le setter)
  // Changement datant du 7 juin 2022 : c'est devenu une classe (pb d'affichage )
  render () {
    const { 
      t, 
      concords, 
      selectedSentId, 
      permalink, 
      isOpenMetadata, 
      getConcordDetail, 
      copyToClipboard, 
      openConlluPopup, 
      lang, 
      concordSpan, 
      collections, 
      docMeta,
      noBrackets
    }=this.props;

    const data=this.state.shuffled? this.shuffleArray(concords): concords;

    //console.log(data);
    
    // -> the display of selection is buggy for Chrome and Opera, and becomes ok after rerender of kwic display
    const displaySelection=navigator.userAgent.match(/Firefox/)?true:false;
    const isUserFrontLoggedIn = !!(Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME));
    if (! data || ! data[0]) { return <></>};

    var COLUMNS;
    var defaultRowPerPage;
    // const [data, setData] = useState(concords);
    // this variable is incremented each time the data are shuffle. It is used to trigger rerendering
    // const [shuffled,setShuffled] = useState(0); 

    const lineHeight=isOpenMetadata? '100px':'30px';
    //console.log("data[0].docId",data[0].docId);
    //console.log("docMeta[data[0].docId]",docMeta[data[0].docId]);    
    const displayPlay=collections[docMeta[data[0].docId].collection]?
      ((collections[docMeta[data[0].docId].collection]['audioLinkPattern'])? true:false):
      false;
    const buttonColWidth=displayPlay? 225:200;
 
    if (isOpenMetadata) {
      defaultRowPerPage=10;
      if (! this.props.retrieveAllSents) {
        COLUMNS=[
          { title: t('leftContext'), 
            field: 'left', 
            render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.left)} /> ,
            cellStyle: {
              width: '40%',
              textAlign:'right'
            },
            headerStyle:{
              textAlign:'center'
            },
            customSort: (a, b) => a.left.split("").reverse().join("") < b.left.split("").reverse().join("")
          // customSort: (a, b) => (a.left.split("").reverse().join("") < b.left.split("").reverse().join("")) ? 1:-1,
          },
          
          { title: t('node'), 
            field: 'node', 
            render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
            cellStyle:{
              textAlign:'center'
            }, 
            headerStyle:{
              textAlign:'center'
            }
          },

          { title: t('rightContext'), 
            field: 'right', 
            render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.right)} /> ,
            cellStyle : {
              width:'40%',
              textAlign:'left'
            },
            headerStyle:{
              textAlign:'center'
            }
          }
        ];
      } else {
        COLUMNS=[
         
          { title: t('node'), 
            field: 'node', 
            render: rowData => <div className='kwicRow' dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
            cellStyle:{
              textAlign:'center'
            }, 
            headerStyle:{
              textAlign:'center'
            }
          }
        ]
      }
    } else {
      defaultRowPerPage=10;
      if (! this.props.retrieveAllSents) {
        COLUMNS=[
          {   
              title: t('info'), 
              render: rowData => 
                <>
                <Button title={t('Info')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"meta")}} icon='info-sign' />
                <Button title={t('Copy')} onClick={ (e)=>{ e.stopPropagation(); copyToClipboard(rowData)}} icon='clipboard'/>
                <Button title={t('Context')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"context")}} icon='align-justify'/>
                <Button title={t('Tokens')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"tokens")}} icon='th' />
                <Button title={t('Tree')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"tree")}} icon='diagram-tree' />
                <Button title={t('Conllu')} onClick={ (e)=>{ 
                                        e.stopPropagation();
                                        openConlluPopup(lang,this.props.docMeta[rowData.docId].collection,rowData.sentId)
                                      }} icon='layout-linear' />
                {  
                  collections && collections[docMeta[rowData.docId].collection] && collections[docMeta[rowData.docId].collection]['audioLinkPattern'] &&
                  <Button onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"audio")}} icon='play' />
                }
                </>,
              cellStyle: {
                  textAlign:'center',
                  padding:'0',
                  width:buttonColWidth,    // seul moyen de fixer la largeur (sans px)
                  maxWidth: buttonColWidth  // seul moyen de fixer la largeur  (sans px)
              },
              headerStyle:{
                  textAlign:'center',
                  padding:'0',
                  width:buttonColWidth,  // seul moyen de fixer la largeur (sans px)
                  maxWidth:buttonColWidth // seul moyen de fixer la largeur (sans px)
              },
              filtering: false
          },
          {   
            title: t('pos'), 
            field: 'pos',
            render: rowData => (isUserFrontLoggedIn)? 
                              <Tooltip2 minimal={false} intent="primary" className={Classes.TOOLTIP2_INDICATOR} content={this.metadata(rowData)}>{rowData.pos}</Tooltip2>:
                              rowData.pos,
            cellStyle: {
                textAlign:'center',
                padding:'0',
                width:40,    // seul moyen de fixer la largeur (sans px)
                maxWidth: 40  // seul moyen de fixer la largeur  (sans px)
            },
            headerStyle:{
                textAlign:'center',
                padding:'0',
                width:40,  // seul moyen de fixer la largeur (sans px)
                maxWidth:40 // seul moyen de fixer la largeur (sans px)
            },
            filtering: false
          },

          {   
              title: t('leftContext'), 
              field: 'left',
              width: '35%',
              render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(specialSlice(rowData.left,'l',concordSpan))} /> ,
              cellStyle: {
                  textAlign:'right',
                  padding:'0',                    
              },
              headerStyle:{
                  textAlign:'center'
              },
              customSort: (a, b) => a.left.split("").reverse().join("") < b.left.split("").reverse().join("")
          },
          {   
              title: t('node'), 
              field: 'node',
              render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
              cellStyle:{
                  textAlign:'center',
                  padding:'0',
                  width:200,
                  maxWidth:200                          
              }, 
              headerStyle:{
                  textAlign:'center',
                  width:200,
                  maxWidth:200
              }
          },
          {   
              title: t('rightContext'), 
              field: 'right', 
              width: '35%',
              render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(specialSlice(rowData.right,'r',concordSpan))} /> ,
              cellStyle : {
                  textAlign:'left',
                  padding:'0',
              },
              headerStyle:{
                  textAlign:'center'
              }
          },
       ];
      } else {
        COLUMNS=[
          {   
              title: t('info'), 
              render: rowData => 
                <>
                <Button title={t('Info')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"meta")}} icon='info-sign' />
                <Button title={t('Copy')} onClick={ (e)=>{ e.stopPropagation(); copyToClipboard(rowData)}} icon='clipboard'/>
                <Button title={t('Context')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"context")}} icon='align-justify'/>
                <Button title={t('Tokens')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"tokens")}} icon='th' />
                <Button title={t('Tree')} onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"tree")}} icon='diagram-tree' />
                <Button title={t('Conllu')} onClick={ (e)=>{ 
                                        e.stopPropagation();
                                        openConlluPopup(lang,this.props.docMeta[rowData.docId].collection,rowData.sentId)
                                      }} icon='layout-linear' />
                {  
                  collections && collections[docMeta[rowData.docId].collection] && collections[docMeta[rowData.docId].collection]['audioLinkPattern'] &&
                  <Button onClick={ (e)=>{ e.stopPropagation(); getConcordDetail(rowData,"audio")}} icon='play' />
                }
                </>,
              cellStyle: {
                  textAlign:'center',
                  padding:'0',
                  width:buttonColWidth,    // seul moyen de fixer la largeur (sans px)
                  maxWidth: buttonColWidth  // seul moyen de fixer la largeur  (sans px)
              },
              headerStyle:{
                  textAlign:'center',
                  padding:'0',
                  width:buttonColWidth,  // seul moyen de fixer la largeur (sans px)
                  maxWidth:buttonColWidth // seul moyen de fixer la largeur (sans px)
              },
              filtering: false
          },
          {   
            title: t('pos'), 
            field: 'pos',
            render: rowData => (isUserFrontLoggedIn)? 
                              <Tooltip2 minimal={false} intent="primary" className={Classes.TOOLTIP2_INDICATOR} content={this.metadata(rowData)}>{rowData.pos}</Tooltip2>:
                              rowData.pos,
            cellStyle: {
                textAlign:'center',
                padding:'0',
                width:40,    // seul moyen de fixer la largeur (sans px)
                maxWidth: 40  // seul moyen de fixer la largeur  (sans px)
            },
            headerStyle:{
                textAlign:'center',
                padding:'0',
                width:40,  // seul moyen de fixer la largeur (sans px)
                maxWidth:40 // seul moyen de fixer la largeur (sans px)
            },
            filtering: false
          },
          {   
              title: t('node'), 
              field: 'node',
              render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
              cellStyle:{
                  textAlign:'center',
                  padding:'0',
                  width:600,
                  maxWidth:600                          
              }, 
              headerStyle:{
                  textAlign:'center',
                  width:600,
                  maxWidth:600
              }
          }
       ];

      }

    // if necessary add a column with the query number
    if (this.props.queryNumber && this.props.queryNumber>1) {
      COLUMNS.splice(0,0, 
        {
          title: t('numQuery'),
          field: 'numQuery',
          cellStyle: {
              textAlign:'center',
              padding:'0',
              width:40,    // seul moyen de fixer la largeur (sans px)
              maxWidth: 40  // seul moyen de fixer la largeur  (sans px)
          },
          headerStyle:{
              textAlign:'center',
              padding:'0',
              width:40,  // seul moyen de fixer la largeur (sans px)
              maxWidth:40 // seul moyen de fixer la largeur (sans px)
          },
          filtering: true
        }
      );
    }

    // if necessary add a column with the subCorpus name
    if (data[0].subCorpus) {
        COLUMNS.splice(1,0, 
          {
            title: t('subCorpus'),
            render: rowData => <span>{ rowData.subCorpus ? '['+(rowData.subCorpus.length>5?rowData.subCorpus.substring(0,2)+"~"+rowData.subCorpus.substring(rowData.subCorpus.length-3,rowData.subCorpus.length):rowData.subCorpus)+'] ':"" }</span>,
            cellStyle: {
              width:100,
              maxWidth: 100,
              textAlign:'center',
              padding:'0',
            },
            headerStyle:{
                width:100,
                maxWidth: 100,
                textAlign:'center',
                padding:'0',
            },
          }
        );
      }

    }

    // la variable d'état 'columns' est utilisée ensuite dans l'action "export the selected rows"
    // const [columns] = useState(COLUMNS); 

    const actionList=[{
      icon: ShuffleIcon,
      isFreeAction: true, // pour avoir un affichage dans l'entête
      tooltip: "Shuffle the rows randomly!",
      onClick: () => {
        this.setState({shuffled: ! this.state.shuffled});
      }
    }
    ];
    // the possibility to select lines is given only for Firefox or if the props.displaySelection is true (because of a display bug)
    if (displaySelection) {
      actionList.push(
        {
          icon: SaveAlt,
          tooltip: "Export the selected rows!",
          onClick: (e,data) => {
              const fileName = "Concordance_Table";
              const builder = new CsvBuilder(
                  fileName + ".csv"
              );
              builder
                  .setColumns(
                      ["numQuery","docId","pos","left","node","right"]
                      .concat(Object.keys(this.props.docMeta[data[0].docId]).sort())
                      .concat( data[0].audioLink ? ["audio"]:[])
                  )
                  .setDelimeter(this.props.csvDelimiter)
                  .addRows(
                    data.map((rowData) =>
                        [
                          rowData.numQuery? rowData.numQuery:1,
                          rowData.docId,
                          rowData.pos,
                          noBrackets? stripBracket(rowData.left):rowData.left,
                          noBrackets? stripBracket(rowData.node):rowData.node,
                          noBrackets? stripBracket(rowData.right):rowData.right,
                        ].concat(Object.keys(this.props.docMeta[rowData.docId]).sort().map( (key,i) => this.props.docMeta[rowData.docId][key]))
                        .concat( data[0].audioLink ? [rowData.audioLink]:[])
                      )
                  )
                  .exportFile();
          },
        },
        {
          icon: Sync,
          tooltip: "Run query only on the selected results!",
          onClick: (e,data) => {
            const selectedSents=data.map((rowData)=>rowData.subCorpus+"/"+this.props.docMeta[rowData.docId].collection+"/"+rowData.sentId);
            console.log("selectedSents",selectedSents)
            this.props.performSearch({selectedSents});

          }
        }
      );
    }

    // console.log("init id="+selectedRowId);
    return (
      <MTable
        title={t('conc')}
        columns={COLUMNS}
        data={data}
        //onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        localization={{
          toolbar: {
            exportCSVName: "Export as CSV",
            exportPDFName: "Export as TXT"
          }
        }}
        options={{
          //selection:navigator.userAgent.match(/Chrom/)?false:true,// to cope with Chrome display bug, selection will not be automatic using Chrome browser
          selection:displaySelection,
          filtering:true,
          search: true,
          sorting: true,
          exportButton: true,
          exportAlldata: false,
          exportCsv: (columns, data) => {
            const fileName = "Concordance_Table";
            const builder = new CsvBuilder(
                fileName + ".csv"
            );
            console.log(data[0]);
            const fields= ["numQuery","sentId","pos","left","node","right"]
                          .concat(Object.keys(this.props.docMeta[data[0].docId]).sort())
                          .concat( data[0].audioLink? ["audio"]:[]);
            //console.log(fields);
            builder
                .setColumns(
                    fields 
                )
                .setDelimeter(this.props.csvDelimiter).addRows(
                  data.map((rowData) => 
                      [
                        rowData.numQuery?rowData.numQuery:1,
                        rowData.sentId,
                        rowData.pos,
                        noBrackets? stripBracket(rowData.left):rowData.left,
                        noBrackets? stripBracket(rowData.node):rowData.node,
                        noBrackets? stripBracket(rowData.right):rowData.right,
                      ].concat(Object.keys(this.props.docMeta[rowData.docId]).sort().map( (key,i) => this.props.docMeta[rowData.docId][key]))
                      .concat( data[0].audioLink ? [rowData.audioLink]:[])
                ))
                .exportFile();
          },
          // override pdf slot to export in txdt
          exportPdf: (columns, data) => {
            const fileName = "Concordance_Table";
            const builder = new CsvBuilder(
                fileName + ".txt"
            );
  
            builder
                .setColumns(
                     ["sentId # sent # meta"]
                )
                .setDelimeter(this.props.csvDelimiter)
                .addRows(
                  data.map((rowData) =>
                      [
                        rowData.sentId,rowData.pos,"\t"+stripBracket(rowData.left+" "+rowData.node+" "+rowData.right)+"\t"+ formatMeta(this.props.docMeta[rowData.docId],this.props.metadataFormat)+"\t"+(rowData.alignedSent?rowData.alignedSent:"")+"\t"+(data[0].audioLink? rowData.audioLink :"")
                      ]
                    )
                )
                .exportFile();
          },
          columnsButton: true,
          //tableLayout: 'fixed',
          padding: 'dense',
          pageSize:defaultRowPerPage,
          
          rowStyle: (rowData) => ({
            backgroundColor: ( selectedSentId === rowData.sentId ) ? '#EEE' : '#FFF',
            height:lineHeight,
            maxHeight:lineHeight
          })
        }}
        icons={{ ViewColumn: ViewColumnIcon }}
        components={{
          Pagination: paginationProps => (
            <TablePagination
              {...paginationProps}
              rowsPerPageOptions={[defaultRowPerPage, 20, 50, 100, 200, data.length]}
            />
          ),
          Container: containerProps => (
            <Paper
              {...containerProps}
              elevation={1}
            />
          ),
          Row: rowProps => (
            <MTableBodyRow
              {...rowProps}
              onRowClick = {(e,rowData) => getConcordDetail(rowData,"")}
              onDoubleClick = { () => { window.open(SERVER_URL+PUBLIC_URL+ANALYTICS_URL+permalink,'_blank') }}
            />
          )
        }}

        // This custom export button id used for selected rows
        actions={ actionList }
      />
    );
  }
};

KwicTable.propTypes = {
  // the concordances of one corpus
  concords: corpusConcordsShape,
  selectedSentId: PropTypes.string,
  permalink: PropTypes.string,
  isOpenMetadata: PropTypes.bool,
  getConcordDetail: PropTypes.func,
  copyToClipboard: PropTypes.func,
  openConlluPopup:  PropTypes.func,
  collections: PropTypes.object,
  lang: PropTypes.string,
  docMeta: PropTypes.object,
  performSearch: PropTypes.func,
  queryNumber:PropTypes.number,
  retrieveAllSents:PropTypes.bool, 
  csvDelimiter: PropTypes.string,
  noBrackets : PropTypes.number,
  metadataFormat: PropTypes.string
};

export default withTranslation()(KwicTable);
